module.exports = __webpack_public_path__ + "static/media/LogoPicture.9078e878.jpg";